import { IconButton } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import React from "react";

interface CalendarButtonProps {
  buttonRef: React.RefObject<null | HTMLButtonElement>;
  itemID?: string;
  disabled?: boolean;
  id?: string;
  EditStyle_Calendar: boolean;
  handleClick: (ev: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void | Promise<void>;
}

export default function CalendarButton(props: CalendarButtonProps) {
  const { buttonRef, itemID, disabled, id, EditStyle_Calendar, handleClick } = props;
  return (
    <IconButton
      ref={buttonRef}
      disabled={disabled}
      aria-describedby={id}
      onClick={(ev) => {
        if (disabled) return;
        handleClick(ev);
      }}
      key={`calendar_${itemID}`}
      className="calendar-button"
      style={{
        width: "20px !important",
        height: "100%",
        borderRadius: "0px",
        padding: "0",
        display: EditStyle_Calendar ? "" : "none",
      }}
    >
      <CalendarTodayIcon style={{ maxHeight: "17px" }} />
    </IconButton>
  );
}
